import React from 'react';
import { Card } from './ui/card';
import { BookOpen, Users, Globe, TrendingUp } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';

const LanguageSection = () => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black mb-4">
            {t('languageSection.title')}
          </h2>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            {t('languageSection.subtitle')}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-12">
          {/* Left: Main Info */}
          <div>
            <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8">
              <BookOpen className="h-12 w-12 mb-4" />
              <h3 className="text-3xl font-black mb-4">{t('languageSection.hoursDaily')}</h3>
              <p className="text-blue-100 mb-6 leading-relaxed">
                {t('languageSection.description')}
              </p>
              <div className="space-y-3">
                <div className="flex items-start">
                  <span className="text-blue-300 mr-2">✓</span>
                  <span className="text-sm">{t('languageSection.feature1')}</span>
                </div>
                <div className="flex items-start">
                  <span className="text-blue-300 mr-2">✓</span>
                  <span className="text-sm">{t('languageSection.feature2')}</span>
                </div>
                <div className="flex items-start">
                  <span className="text-blue-300 mr-2">✓</span>
                  <span className="text-sm">{t('languageSection.feature3')}</span>
                </div>
                <div className="flex items-start">
                  <span className="text-blue-300 mr-2">✓</span>
                  <span className="text-sm">{t('languageSection.feature4')}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Features Grid */}
          <div className="grid grid-cols-2 gap-4">
            <Card className="p-6 bg-white/10 backdrop-blur-sm border-white/20 text-center">
              <Users className="h-8 w-8 mx-auto mb-3" />
              <h4 className="font-black text-lg mb-2">{t('languageSection.interactiveLearning')}</h4>
              <p className="text-sm text-blue-100">{t('languageSection.interactiveLearningDesc')}</p>
            </Card>

            <Card className="p-6 bg-white/10 backdrop-blur-sm border-white/20 text-center">
              <Globe className="h-8 w-8 mx-auto mb-3" />
              <h4 className="font-black text-lg mb-2">{t('languageSection.multicultural')}</h4>
              <p className="text-sm text-blue-100">{t('languageSection.multiculturalDesc')}</p>
            </Card>

            <Card className="p-6 bg-white/10 backdrop-blur-sm border-white/20 text-center">
              <TrendingUp className="h-8 w-8 mx-auto mb-3" />
              <h4 className="font-black text-lg mb-2">{t('languageSection.provenResults')}</h4>
              <p className="text-sm text-blue-100">{t('languageSection.provenResultsDesc')}</p>
            </Card>

            <Card className="p-6 bg-white/10 backdrop-blur-sm border-white/20 text-center">
              <BookOpen className="h-8 w-8 mx-auto mb-3" />
              <h4 className="font-black text-lg mb-2">{t('languageSection.certificate')}</h4>
              <p className="text-sm text-blue-100">{t('languageSection.certificateDesc')}</p>
            </Card>
          </div>
        </div>

        {/* Learning Methods */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8">
          <h3 className="text-2xl font-black mb-6 text-center">{t('languageSection.howYoullLearn')}</h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-4xl font-black text-blue-300 mb-2">01</div>
              <h4 className="font-bold mb-2">{t('languageSection.inClassroom')}</h4>
              <p className="text-sm text-blue-100">
                {t('languageSection.inClassroomDesc')}
              </p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-black text-blue-300 mb-2">02</div>
              <h4 className="font-bold mb-2">{t('languageSection.onField')}</h4>
              <p className="text-sm text-blue-100">
                {t('languageSection.onFieldDesc')}
              </p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-black text-blue-300 mb-2">03</div>
              <h4 className="font-bold mb-2">{t('languageSection.dailyLife')}</h4>
              <p className="text-sm text-blue-100">
                {t('languageSection.dailyLifeDesc')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LanguageSection;